/**
 * Spanish strings for the player's own keys.
 *
 * Media Chrome ships this language for its controls; the keys the player adds,
 * casting, preview and its error messages, would otherwise fall back to English.
 */
import { Es as MediaChromeEs } from 'media-chrome/lang/es.js';
import type { TranslateDictionary } from './en.js';

export const Es: TranslateDictionary = {
  ...MediaChromeEs,
  'Casting to {device}': 'Transmitiendo a {device}',
  preview: 'Vista previa',
  "This video cannot be played on your device because it doesn't meet the content protection requirements.":
    'Este video no se puede reproducir en tu dispositivo porque no cumple los requisitos de protección de contenido.',
  'There was an error with the content protection system.':
    'Se produjo un error en el sistema de protección de contenido.',
  'This video requires a secure connection (HTTPS) to play DRM-protected content.':
    'Este video requiere una conexión segura (HTTPS) para reproducir contenido protegido con DRM.',
  'An error occurred during playback. The media could not be loaded.':
    'Se produjo un error durante la reproducción. No se pudo cargar el contenido.',
  'This video uses a codec (HEVC) that is not supported by your browser. Please try a different browser such as Chrome or Safari.':
    'Este video usa un códec (HEVC) que tu navegador no admite. Prueba con otro navegador, como Chrome o Safari.',
  'There was an error during initialization of the DRM system.':
    'Se produjo un error al inicializar el sistema DRM.',
  'The content license has expired.': 'La licencia del contenido ha caducado.',
  'This video is not available.': 'Este video no está disponible.',
  'This video could not be found.': 'No se encontró este video.',
};
